enum SeedCropRoutes {
  List = '/seed-crops',
  Add = '/seed-crops/add',
  Edit = '/seed-crops/edit/:id',
}

export default SeedCropRoutes
